import {Component, Input} from '@angular/core';
import {CoursePageData} from '../../course-page/course-page-data.model';
import {isValidCoupon} from '../../models/coupon.model';
import {UrlBuilderService} from '../../services/url-builder.service';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {selectActiveCourse} from '../../store/selectors';
import {concatMap, tap} from 'rxjs/operators';
import {AppState} from '../../store';
import {MessagesService} from '../../shared/services/messages.service';
import {PurchasesService} from '../../services/purchases.service';
import {Meta, Title} from '@angular/platform-browser';
import {TrackingService} from '../../services/tracking.service';
import {CourseCouponsDbService} from '../../services/course-coupons-db.service';
import {Timestamp} from '@firebase/firestore';
import dayjs from 'dayjs';
import {TranslateModule} from '@ngx-translate/core';
import {CurrencyPipe, DatePipe, NgIf, NgStyle} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';

@Component({
    selector: 'pricing-info',
    templateUrl: './pricing-info.component.html',
    styleUrls: ['./pricing-info.component.scss'],
    imports: [NgIf, NgStyle, CurrencyPipe, DatePipe, TranslateModule, MatIconModule]
})
export class PricingInfoComponent {
  @Input()
  data: CoursePageData

  couponCode: string;
  awardUrl: string;
  cardPaymentUrl: string;

  constructor(
              private store: Store<AppState>,
              private route: ActivatedRoute,
              private messages: MessagesService,
              private purchases: PurchasesService,
              private title: Title,
              private meta: Meta,
              private ub: UrlBuilderService,
              private router: Router,
              private tracking: TrackingService,
              private dbCoupons: CourseCouponsDbService,

  ) {
  }

  ngOnInit() {
    this.awardUrl = this.ub.buildImageUrl("/icons/award.svg");
    this.cardPaymentUrl = this.ub.buildImageUrl("/images/icons/CardPayButtons.svg");
    this.couponCode = this.route.snapshot.queryParamMap.get("couponCode");
    this.createCoursePageDataObservable(this.couponCode);
  }

  createCoursePageDataObservable(
    couponCode: string
  ) {
    if (couponCode) {
      const course$ = this.store.pipe(select(selectActiveCourse));

      const loadCoupon$ = course$.pipe(
        concatMap((course) =>
          this.dbCoupons.findCouponByCode(course.id, couponCode).pipe(
            tap((coupon) => {
              if (!coupon) {
                this.messages.i18nError(
                  "course.messages.couldNotFindCouponCode",
                  {
                    couponCode,
                  }
                );
              } else if (!isValidCoupon(coupon)) {
                this.messages.i18nWarn(
                  "course.messages.couponCodeIsNoLongerValid",
                  {
                    couponCode: coupon.code,
                  }
                );
              } else {
                if (coupon.free) {
                  this.messages.i18nSuccess(
                    "course.messages.freeCouponIsValidClaimYourFreeCourse"
                  );
                }
              }
            })
          )
        )
      );

      loadCoupon$.subscribe(loadCoupon => {
        this.data = {
          ...this.data,
          coupon: loadCoupon,
          couponValid: isValidCoupon(loadCoupon)
        }
      })
    }
  }

  isSubscribeButtonVisible(data: CoursePageData) {
    return (
      data.tenant.isConnectedToStripe &&
      !!data.tenant?.pricingPlans &&
      !data.tenant?.subscriptionScreenDisabled
    );
  }

  getDaysLeft(deadline: Timestamp): number {
    if (!deadline) {
      return 0;
    }

    const now = dayjs();
    const expiresAt = dayjs(deadline.toDate());

    return expiresAt.diff(now, "day");
  }
}
